import axios from 'axios';
import config from 'config';

class AuthApi {
  constructor({ apiURL, clientId }) {
    this.apiURL = apiURL;
    this.clientId = clientId;
    this.instance = axios.create({
      baseURL: this.apiURL,
    });

    this.getToken = this.getToken.bind(this);
    this.refreshToken = this.refreshToken.bind(this);
  }

  getToken = ({ username, password }) =>
    this.instance.post('auth/token/', {
      grant_type: 'password',
      client_id: this.clientId,
      username,
      password,
    });

  refreshToken = (refreshToken) =>
    this.instance.post('auth/token/', {
      grant_type: 'refresh_token',
      client_id: this.clientId,
      refresh_token: refreshToken,
    });
}

export default new AuthApi({
  apiURL: config.API_URL,
  clientId: config.ONTRUCK_AUTH_CLIENTID,
});
